/*
  As chaves de layout de um `style` de antes do Design System: largura, margens e o encaixe no flex.
  Os campos da lib têm o visual próprio (altura, cantos, sombra), então os adaptadores do site
  (DateInput, Select) só repassam estas, numa `div` em volta do campo.
*/
const LAYOUT_KEYS = [
  'width', 'minWidth', 'maxWidth', 'flex', 'flexGrow', 'flexShrink', 'flexBasis', 'alignSelf',
  'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginInline', 'marginBlock'
]

export default function layoutOf(style) {
  return Object.fromEntries(
    Object.entries(style || {}).filter(([key]) => LAYOUT_KEYS.includes(key))
  )
}
